import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
// Chat assistant switched off for now (Oct 2026). To bring it back, uncomment this
// import and <ChatAssistant /> below.
// import ChatAssistant from './components/ChatAssistant';
import Login from './components/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { API } from './services/api';

// The guest catering heatmap, a separate app (rsbbq/rsbbq-catering-map). It has no
// logins of its own: it asks this dashboard's /api/me whether the token it is given
// belongs to a current user.
const HEATMAP_URL = process.env.REACT_APP_HEATMAP_URL || 'https://heatmap.rsbbq.org';

// POST the login token in a form, not a link with it in the URL, so the token never
// lands in browser history or in the heatmap's request logs. Opens in a new tab.
function openHeatmap(token) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${HEATMAP_URL}/login`;
  form.target = '_blank';
  form.rel = 'noopener';
  const field = document.createElement('input');
  field.type = 'hidden';
  field.name = 'token';
  field.value = token;
  form.appendChild(field);
  document.body.appendChild(form);
  form.submit();
  form.remove();
}

function AppContent() {
  const { isAuthenticated, user, token, logout, loading: authLoading } = useAuth();
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check API health on mount
    API.getHealth()
      .then(data => {
        setHealth(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('API health check failed:', error);
        setLoading(false);
      });
  }, []);

  if (authLoading || loading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!health) {
    return (
      <div className="app-error">
        <h1>⚠️ Connection Error</h1>
        <p>Unable to connect to the API server.</p>
        <p>Make sure the backend is running on {process.env.REACT_APP_API_URL || 'http://localhost:3001'}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-left">
          <h1>📊 RSBBQ Inventory Dashboard</h1>
          <div className="header-status">
            <span className="status-indicator status-ok"></span>
            <span>API Connected</span>
          </div>
        </div>
        <div className="header-right">
          <span className="user-info">Welcome, {user?.username}</span>
          <button onClick={() => openHeatmap(token)} className="logout-button">
            🗺️ HeatMap
          </button>
          <button onClick={logout} className="logout-button">
            Logout
          </button>
        </div>
      </header>
      <Dashboard />
      {/* <ChatAssistant /> */}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;

